export const MIN_MANAGE_SIDEBAR_WIDTH = 180;
export const MAX_MANAGE_SIDEBAR_WIDTH = 360;
export const DEFAULT_MANAGE_SIDEBAR_WIDTH = 200;

export function maxManageSidebarWidth(viewportWidth) {
    return Math.max(MIN_MANAGE_SIDEBAR_WIDTH, Math.min(MAX_MANAGE_SIDEBAR_WIDTH, Math.floor(viewportWidth * 0.34)));
}

export function clampManageSidebarWidth(width, viewportWidth) {
    const requested = Number.isFinite(Number(width)) ? Number(width) : DEFAULT_MANAGE_SIDEBAR_WIDTH;
    return Math.round(Math.min(maxManageSidebarWidth(viewportWidth), Math.max(MIN_MANAGE_SIDEBAR_WIDTH, requested)));
}
